import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  private readonly url: string;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly http: HttpClient,
    private readonly router: Router,
  ) {
    this.url = `${environment.ssoUrl}${environment.ssoLogoutUrl}`;
  }

  async ngOnInit(): Promise<void> {
    this.http
      .get<any>(this.url)
      .pipe()
      .subscribe((_resData: null) => {
        window.location.href = environment.ssoProviderLogoutUrl + location.origin;
      });
  }
}
